// extracted by mini-css-extract-plugin
export default {"frontWrap":"frontWrap---BLRRZ","frontTitle":"frontTitle---fRocm"};